'use client';

import { cn } from '@/lib/utils';
import useSectionPosition from '@/hooks/useSectionPosition';

interface ProgressBarProps extends React.HTMLAttributes<HTMLDivElement> {
  color?: 'primary-600' | 'white';
}

export default function ProgressBarHomepage(props: ProgressBarProps) {
  const { color = 'white', className } = props;
  const { progress } = useSectionPosition(document.querySelectorAll('section'));

  return (
    <div
      className={cn(
        'progress-bar h-px w-full transform lg:h-1',
        color && `bg-${color}`,
        className,
      )}
      style={{ maxWidth: `${progress}%` }}
    ></div>
  );
}
